<template>
    <div>
        <div class="row g-3 mb-4 align-items-center justify-content-between">
            <div class="col-auto">
                <h1 class="app-page-title mb-0">Systeembeheer</h1>
            </div>
        </div>

        <!-- Database Section -->
        <div class="row g-4">
            <div class="col-12 col-lg-6">
                <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
                    <div class="app-card-header p-3 border-bottom-0">
                        <div class="row align-items-center gx-3">
                            <div class="col-auto">
                                <div class="app-icon-holder">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-database" viewBox="0 0 16 16">
                                        <path d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313ZM13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A4.92 4.92 0 0 0 13 5.698ZM14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13V4Zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A4.92 4.92 0 0 0 13 8.698Zm0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525Z"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-auto">
                                <h4 class="app-card-title">Database Backup</h4>
                            </div>
                        </div>
                    </div>
                    <div class="app-card-body px-4">
                        <div class="intro mb-3">
                            Export de volledige database naar een SQL bestand. Dit bestand kan worden gebruikt voor backup doeleinden of om de database te migreren naar een andere server.
                        </div>
                        <button
                            class="btn app-btn-primary"
                            @click="exportDatabase"
                            :disabled="isExporting">
                            <span v-if="!isExporting">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download me-2" viewBox="0 0 16 16">
                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                </svg>
                                Database Exporteren
                            </span>
                            <span v-else>
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Exporteren...
                            </span>
                        </button>
                    </div>
                    <div class="app-card-footer p-4 mt-auto">
                        <small class="text-muted">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-info-circle me-1" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                            </svg>
                            Let op: De export kan enkele minuten duren afhankelijk van de grootte van de database.
                        </small>
                    </div>
                </div>
            </div>

            <!-- Cache Section -->
            <div class="col-12 col-lg-6">
                <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
                    <div class="app-card-header p-3 border-bottom-0">
                        <div class="row align-items-center gx-3">
                            <div class="col-auto">
                                <div class="app-icon-holder">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-auto">
                                <h4 class="app-card-title">Cache Beheer</h4>
                            </div>
                        </div>
                    </div>
                    <div class="app-card-body px-4">
                        <div class="intro mb-3">
                            Wis de applicatie cache om problemen op te lossen of om configuratiewijzigingen door te voeren.
                        </div>
                        <div class="text-muted">
                            <em>Functionaliteit komt binnenkort beschikbaar...</em>
                        </div>
                    </div>
                </div>
            </div>

            <!-- System Info Section -->
            <div class="col-12">
                <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
                    <div class="app-card-header p-3 border-bottom-0">
                        <div class="row align-items-center gx-3">
                            <div class="col-auto">
                                <div class="app-icon-holder">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-info-square" viewBox="0 0 16 16">
                                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-auto">
                                <h4 class="app-card-title">Systeeminformatie</h4>
                            </div>
                        </div>
                    </div>
                    <div class="app-card-body px-4">
                        <div class="intro mb-3">
                            <em>Systeeminformatie komt binnenkort beschikbaar...</em>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SystemAdminComponent",

    data() {
        return {
            isExporting: false
        }
    },

    methods: {
        exportDatabase() {
            if (this.isExporting) return;

            Swal.fire({
                title: 'Database Exporteren?',
                text: 'Dit kan enkele minuten duren afhankelijk van de grootte van de database.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Ja, exporteer',
                cancelButtonText: 'Annuleren',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    this.isExporting = true;

                    return axios.post('/system/export-database', {}, {
                        responseType: 'blob'
                    })
                    .then(response => {
                        // Create download link
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;

                        // Extract filename from content-disposition header or use default
                        const contentDisposition = response.headers['content-disposition'];
                        let filename = 'database_backup_' + new Date().toISOString().slice(0, 19).replace(/:/g, '-') + '.sql';

                        if (contentDisposition) {
                            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                            if (filenameMatch && filenameMatch.length === 2) {
                                filename = filenameMatch[1];
                            }
                        }

                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);

                        return { success: true };
                    })
                    .catch(error => {
                        console.error('Export failed:', error);
                        let errorMessage = 'Er is een fout opgetreden tijdens het exporteren van de database.';

                        if (error.response && error.response.data) {
                            // Try to parse error message from blob
                            const reader = new FileReader();
                            reader.onload = function() {
                                try {
                                    const errorData = JSON.parse(reader.result);
                                    if (errorData.message) {
                                        Swal.showValidationMessage(errorData.message);
                                    }
                                } catch (e) {
                                    Swal.showValidationMessage(errorMessage);
                                }
                            };
                            reader.readAsText(error.response.data);
                        }

                        throw new Error(errorMessage);
                    })
                    .finally(() => {
                        this.isExporting = false;
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then(result => {
                if (result.isConfirmed && result.value && result.value.success) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Database succesvol geëxporteerd!'
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.app-icon-holder {
    width: 60px;
    height: 60px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e7f3ff;
    border-radius: 10px;
    font-size: 1.5rem;
    color: #0d6efd;
}

.app-card {
    height: 100%;
}

.app-card-basic {
    border: 1px solid rgba(0,0,0,.125);
    border-radius: 0.375rem;
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
    border-width: 0.2em;
}
</style>
